import { render, staticRenderFns } from "./DocumentListView.vue?vue&type=template&id=698a0564&scoped=true"
import script from "./DocumentListView.vue?vue&type=script&lang=js"
export * from "./DocumentListView.vue?vue&type=script&lang=js"
import style0 from "./DocumentListView.vue?vue&type=style&index=0&id=698a0564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698a0564",
  null
  
)

export default component.exports